export { EarlyDocumentsBadge } from './EarlyDocumentsBadge';
export { EARLY_DOCUMENTS_EVENTS } from './EarlyDocumentsBadge.events';
